<template>
  <div id="app">
    <TheNavBar></TheNavBar>
    <flash-message></flash-message>
    <Prompt></Prompt>
    <router-view />
    <div v-if="showNewVersion" class="asd-modal-overlay">
      <div class="asd-modal">
        <div class="asd-modal-title">
          Nová verze - {{ VERSION_TAG }}
        </div>
        <div class="asd-modal-content">
          <ul>
            <li v-for="(line, $index) in currentVersion.text" :key="$index" v-html="line"></li>
          </ul>
        </div>
        <div class="asd-modal-controls">
          <button class="asd-btn-confirm" @click="confirmCurrentVersion()">
            Budiž...
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import TheNavBar from 'CORE/components/nav-bar/the-nav-bar'
import versions, { VERSION_TAG } from '@/versions'
import _ from 'lodash'
import appReady from 'CORE/utils/app-ready'
import Prompt from 'CORE/utils/prompt/component'

export default {
    name: 'App',
    components: {
        TheNavBar,
        Prompt,
    },
    data: function() {
        return {
            loggedIn: Vue.$jwt.hasToken(),
            showNewVersion: false,
        }
    },
    computed: {
        VERSION_TAG() {
            return VERSION_TAG
        },
        versions() {
            return versions
        },
        currentVersion() {
            try {
                const head = _.head(_.filter(versions, { tag: VERSION_TAG }))
                if (head) return head
                return { order: -1, text: [], tag: 'beta' }
            } catch (e) {
                return { order: -1, text: [], tag: 'beta' }
            }
        },
    },
    async mounted() {
        await appReady()
        const user = this.$store.getters.currentUser
        const currentVersion = this.currentVersion
        const lastSeenOrder = _.get(user, 'settings.lastSeenOrder', -1)
        if (currentVersion.order > lastSeenOrder) {
            this.showNewVersion = true
        }
    },
    methods: {
        async confirmCurrentVersion() {
            const user = this.$store.getters.currentUser
            this.$set(user.settings, 'lastSeenOrder', this.currentVersion.order)
            await this.$store.dispatch('updateUser', user)
            this.showNewVersion = false
        },

    },
}

</script>

<style lang="scss">
@import './less/index.scss';

$light-grey: #ecf0f1;
$grey: #bdc3c7;
$blue: #22a7f0;
$blue-sec: #1872ae;
$red: #c93756;
$red-sec: #951730;
$green: #049372;
$green-sec: #01785C;
$yellow: #ffa400;
$yellow-sec: #B77400;

.asd-modal-overlay {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5000;
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    background-color: rgba(0,0,0,0.5);
    .asd-modal {
        border: 1px solid var(--color-primary);
        background-color: var(--color-primary-inverse);
        color: var(--color-primary);
        min-width: 300px;
        max-width: 95vw;
        border-radius: 3px;
        box-shadow: 0px 0px 3px 0px rgba(0,0,0,0.15);
        &-title {
            text-align: center;
            margin: 25px;
            h1 {
              font-size: 1.8rem;
              margin: 0 auto 30px auto;
            }
        }
        &-content {
            padding: 10px;
            li {
                margin-left: 30px;
                margin-top: 5px;
            }
        }
        &-controls {
            display: flex;
            justify-content: space-evenly;
            padding: 10px;
            border-top: 1px solid var(--color-primary);
            background-color: rgba(0,0,0,0.05);
        }
    }
}

// Buttons
.btn-danger {
  background: $red;
  border-color: $red;
  &:hover {
    background: $red-sec;
    border-color: $red-sec;
  }
}
.btn-danger {
  background: $red;
  border-color: $red;
  &:hover {
    background: $red-sec;
    border-color: $red-sec;
  }
}
.btn-primary {
  background: $blue;
  border-color: $blue;
  &:hover {
    background: $blue-sec;
    border-color: $blue-sec;
  }
}
.btn-success {
  background: $green;
  border-color: $green;
  &:hover {
    color: white;;
    background: $green-sec;
  }
}
// .lang-selector {
//   border-radius: 0;
//   background-color: $blue;
//   color: white;
// }
// .btn-profile{
//   background:$blue-sec;
//   color: #fff;
//   border-radius: 0;
//   border: 2px solid transparent;
//   &:hover{
//     background :$blue;
//     color: #fff;
//   }
// }
// .btn-logout{
//   background:$red;
//   color: #fff;
//   border-radius: 0;
//   border: 2px solid transparent;
//   &:hover{
//     background :$red-sec;
//     color: #f2f2f2
//   }
// }

.sorting-row th.active_desc {
    color: lightgoldenrodyellow;
    background: $blue;
}

// .nav-separator {
//     width: 1px;
//     background-color: rgba(0, 123, 255, 0.5);
//     background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.1) 20%,rgba(0,0,0,0.1) 80%,rgba(0,0,0,0) 100%);
// }
// .btn {
//   font-size: 15px;
//   line-height: 1.2;
//   padding-top: 4px !important;
//   padding-bottom: 4px !important;
// }
// .my-3 {
//   margin-top: 0.5rem !important;
//   margin-bottom: 0.5rem !important;
// }
.main-container{
    width: 100vw;
    height: calc(100vh - 30px);
    background: whitesmoke;
    display: flex;
    flex-direction: row;
    #content {
      overflow: scroll;
      flex-grow: 1;
    }
}

.flash__wrapper{
  position: fixed;
  z-index: 6000;
  margin: auto;
  left: 50%;
  transform: translate(-50%, 0);
  top: 8%;
}
.flash__message{
  padding:15px 45px 15px 45px;
}

.darkgrey-text {
  color: #3d3d3d;
}
.badge-h1 {
  font-size: 50%;
  vertical-align: middle;
  margin-left: 10px;
}
.andere {
  background-color: #eee;
}
.active-color {
  border: 3px solid #4f4f4f;
}

// table.fixed-pagination {
//     margin-bottom: 78px;
// }
// table.fixed-pagination + nav {
//     background-color: #343a40;
//     position: fixed;
//     bottom: 32px;
//     left: 0;
//     height: 42px;
//     padding: 4px 10px 0 10px;
//     width: 100vw;
//     z-index: 999;
// }

.btn-menu-show {
  position: absolute;
  top: 34px;
  left: 0;
  background: $green;
  border-radius: 0;
  color: #fff;
  padding-left: .48rem;
  padding-right: .48rem;
  opacity: 60%;
  &:hover {
    opacity: 85%;
    background: $green-sec;
    color: #fff;
  }
}
.btn-menu-hide {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 2;
  background: $red;
  border-radius: 0;
  color: #fff;
  padding-left: .60rem;
  padding-right: .60rem;
  opacity: 60%;
  &:hover {
    opacity: 85%;
    background: $red-sec;
    color: #fff;
  }
}
.page-head {
  padding-left: 35px;
  margin-bottom: 25px;
}
</style>
